import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  is_loaded: false,
  is_scene_loaded: false,
  template_data: null,
  scene_data: null,
};

const templateSlice = createSlice({
  name: "templates",
  initialState,
  reducers: {
    resetState(state) {
      state.is_loaded = false;
      state.is_scene_loaded = false;
      state.template_data = null;
      state.scene_data = null;
    },
    setTemplateData(state, action) {
      state.is_loaded = true;
      state.template_data = action.payload.template_data;
    },
    setSceneData(state, action) {
      state.is_scene_loaded = true;
      state.scene_data = action.payload.scene_data;
    },
  },
});

export const templateAction = templateSlice.actions;
export default templateSlice.reducer;
